import { SimpleDocCommand } from '../DocsApp/commands/v5/types';
import { CommandExecutionContext } from '../../types/commands';
import { StandardToolResult } from '../../types/standardToolResults';
import fetchService from '../../services/fetchService';
import { API_BASE_URL } from '../../api/config';
import { MANIFEST } from './slack_read_dm.m';
import { schemaToParameters } from '../../utils/schemaToParameters';

const log = { log: (...a: any[]) => console.log('[SLACK_QUERY_TOOL]', ...a) };

export const slack_read_dm: SimpleDocCommand = {
  id: MANIFEST.name,
  logicalName: 'slack_read_dm',
  version: 'v1',
  description: MANIFEST.description,

  schema: {
    parameters: schemaToParameters(MANIFEST.inputSchema),
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { slackUserId, workspaceId, limit = 20 } = params;

    if (!slackUserId?.trim()) {
      return { status: 'error', message: 'slackUserId is required', format: 'plaintext' };
    }

    try {
      const urlParams = new URLSearchParams();
      urlParams.set('slack_user_id', slackUserId);
      if (workspaceId) urlParams.set('workspace_id', workspaceId);
      urlParams.set('limit', String(Math.min(100, Math.max(1, limit))));

      const data = await fetchService(
        `${API_BASE_URL}/integrations/slack/dm-history?${urlParams}`,
        { method: 'GET' }
      );

      if (data.error || data.detail) {
        const detail = data.detail || data.error;
        return {
          status: 'error',
          message: detail.includes('not connected')
            ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
            : `Slack read-dm failed: ${detail}`,
          error: { code: 'read_dm_failed', category: 'execution', details: detail },
          format: 'plaintext',
        };
      }

      const messages = Array.isArray(data) ? data : [];
      log.log(`read-dm: found ${messages.length} messages for ${slackUserId}`);
      return {
        status: 'success',
        message: `Retrieved ${messages.length} message${messages.length !== 1 ? 's' : ''} from DM with ${slackUserId}`,
        data: { messages, count: messages.length, slackUserId },
        format: 'json',
      };
    } catch (error: any) {
      const detail = error.data?.detail || error.message || 'Unknown error';
      return {
        status: 'error',
        message: detail.includes('not connected')
          ? 'Slack is not connected. Connect a workspace in Settings → Integrations.'
          : `Slack read-dm failed: ${detail}`,
        error: { code: 'error', category: error.status === 400 ? 'validation' : 'execution', details: detail },
        format: 'plaintext',
      };
    }
  },
};
